<template>
  <div :class="{ expanded: isExpanded, collapsed: !isExpanded }">
    <div class="title"
         v-on:click="toggleExpand">{{ title }}</div>
    <div class="content"
         ref="content"
         :style="{ height: `${contentHeight}px` }">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String
  },
  data() {
    return {
      isExpanded: true,
      contentHeight: 0
    };
  },
  watch: {
    isExpanded(value) {
      this.contentHeight = value ? this.$refs.content.scrollHeight : 0;
    }
  },
  mounted() {
    this.contentHeight = this.$refs.content.scrollHeight;
  },
  methods: {
    toggleExpand() {
      this.isExpanded = !this.isExpanded;
    }
  }
};
</script>

<style lang="scss" scoped>
.title {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 18px;
  color: #6c6c6c;
  font-weight: bold;
  border-bottom: 1px solid #e4e4e4;
  padding-bottom: 10px;

  &:after {
    content: "";
    display: block;
    width: 15px;
    height: 15px;
    margin-left: 10px;
  }
}

.content {
  transition: height 0.5s;
  overflow: hidden;
}

.expanded {
  .title:after {
    background-image: url("../assets/collapse.svg");
  }
}

.collapsed {
  .title:after {
    background-image: url("../assets/expand.svg");
  }
}
</style>
